import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';

const TextEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value);
  const editorRef = useRef(null);

  useEffect(() => {
    const editor = editorRef.current;

    if (!editor) {
      return undefined;
    }

    const stopNavigation = event => {
      if ([32, 37, 38, 39, 40, 36, 35, 9].includes(event.keyCode)) {
        event.stopPropagation();
      }
    };

    editor.addEventListener('keydown', stopNavigation);

    return () => {
      editor.removeEventListener('keydown', stopNavigation);
    };
  }, []);

  // Expose methods to ag-Grid using `useImperativeHandle`
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => value, // Return the updated value
      isPopup: () => false, // Indicate whether it's a popup
      afterGuiAttached: () => {
        if (editorRef.current) {
          editorRef.current.select();
        }
      },
    }),
    [value],
  );

  const handleChange = event => {
    setValue(event.target.value);
  };

  return <input ref={editorRef} className="form-control input-sm" onChange={handleChange} type="text" value={value} />;
});

export default TextEditor;
